import { Component, input } from '@angular/core';
import { IconComponent } from '../../../icons/icon/icon.component';
import { FormFieldLabelAddons } from '../../form-field.interface';

@Component({
  selector: 'ui-form-field-label',
  templateUrl: './form-field-label.component.html',
  styleUrl: './form-field-label.component.scss',
  standalone: true,
  imports: [IconComponent],
})
export class FormFieldLabelComponent {
  readonly label = input.required<string>();
  readonly addons = input<FormFieldLabelAddons>();
  readonly layout = input<'vertical' | 'horizontal'>('vertical');
}
